import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const Container = styled.div`
  ${tw`max-w-lg mx-auto p-6 flex flex-col items-center justify-center max-w-full min-w-0 box-border`}
`;

const TitleSkeleton = styled(Skeleton)`
  ${tw`h-8 w-48 mb-8`}
`;

const LocationSection = styled.div`
  ${tw`mb-6 w-full`}
`;

const SectionTitleSkeleton = styled(Skeleton)`
  ${tw`h-6 w-32 mb-2`}
`;

const DescriptionSkeleton = styled(Skeleton)`
  ${tw`h-4 w-full mb-4`}
`;

const LabelSkeleton = styled(Skeleton)`
  ${tw`h-5 w-48 mb-2`}
`;

const InputContainerSkeleton = styled.div`
  ${tw`w-full max-w-md mx-auto mt-6 mb-4`}
`;

const SelectSkeleton = styled(Skeleton)`
  ${tw`w-full h-10 rounded-md`}
`;

const ButtonContainerSkeleton = styled.div`
  ${tw`flex justify-center w-full mt-6`}
`;

const ButtonSkeleton = styled(Skeleton)`
  ${tw`w-full h-12 rounded-md`}
`;

const AddCarPageSkeleton: React.FC = () => {
  return (
    <Container>
      <TitleSkeleton />
      <LocationSection>
        <SectionTitleSkeleton />
        <DescriptionSkeleton />
        <DescriptionSkeleton width="80%" />
        <LabelSkeleton />
        <InputContainerSkeleton>
          <SelectSkeleton />
        </InputContainerSkeleton>
      </LocationSection>
      <ButtonContainerSkeleton>
        <ButtonSkeleton />
      </ButtonContainerSkeleton>
    </Container>
  );
};

export default AddCarPageSkeleton;
